import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-deployment',
  templateUrl: './deployment.component.html',
  styleUrls: ['./deployment.component.scss']
})
export class DeploymentComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Deployment Process - Xipe Tech';
  contentDescription = 'XipeTech’s streamlined deployment process designed to ensure fast, reliable, and secure implementation of IT solutions. From planning to execution, we deliver smooth, error-free launches tailored to your business needs.';
  contentKeywords = 'deployment process, software deployment, IT deployment, deployment strategy, deployment planning, application deployment, cloud deployment, secure deployment, DevOps deployment, deployment best practices, automated deployment, XipeTech deployment services';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
